<form class="wrapper" [formGroup]="formData" (ngSubmit)="onSubmit()">
  <wl-progress-bar [percentage]="questionData().percentage" />

  <crnt-radio-group>
    <crnt-form-control-label slot="legend">
      <strong class="font-size-lg font-weight-black">
        {{ questionData().question }}
      </strong>
    </crnt-form-control-label>

    @if (questionData().subtitle) {
      <crnt-form-control-help-text slot="help">
        {{ questionData().subtitle }}
      </crnt-form-control-help-text>
    }

    @if (chosenAnswer.invalid && chosenAnswer.touched) {
      <crnt-form-control-validation-message>
        {{ rendering.invalidMessage }}
      </crnt-form-control-validation-message>
    }

    @if (questionData().info; as info) {
      <div>
        <crnt-button
          variant="tertiary"
          (click)="requestInfo.emit(info.target)"
          wlAutomationId="questionnaire-moreInfo"
          class="btn-info"
        >
          {{ info.label }}
        </crnt-button>
      </div>
    }

    @for (option of questionData().options; track option) {
      @let optionId = optionToId(option);
      <crnt-radio bordered [wlAutomationId]="option.automationId">
        <input
          type="radio"
          [attr.name]="questionData().apiKey"
          [value]="option"
          formControlName="chosenAnswer"
          [attr.id]="optionId"
        />
        <label [for]="optionId" slot="label">{{ option.label }}</label>
      </crnt-radio>
    }
  </crnt-radio-group>

  <div class="buttons">
    <crnt-button
      fullWidth
      wlAutomationId="questionnaire-nextQuestion"
      type="submit"
      >{{ rendering.nextQuestion }}</crnt-button
    >

    @if (showPrevious()) {
      <crnt-button
        fullWidth
        variant="tertiary"
        (click)="back.emit()"
        wlAutomationId="questionnaire-previousQuestion"
        class="btn-previous"
      >
        <crnt-icon icon="arrow-left" slot="leading" />
        {{ rendering.previousLabel }}
      </crnt-button>
    }
  </div>
</form>
